import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import DashboardDetailsGrid from 'src/components/DashboardDetailsGrid';
import DashboardReportingAuditingSplash from 'src/components/DashboardReportingAuditingSplash';
import MobileGeographySection from 'src/components/MobileGeographySection';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import UptimeSplash from 'src/components/UptimeSplash';

import ImgIphoneDashboard from 'src/images/img-iphone-dashboard.png';
import ImgIphoneDashboard2x from 'src/images/img-iphone-dashboard@2x.png';
import IconDashboard from 'src/images/icon-dashboard.png';
import IconDashboard2x from 'src/images/icon-dashboard@2x.png';
import IconDashboard3x from 'src/images/icon-dashboard@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconDashboard, IconDashboard2x, IconDashboard3x]} />
              <div className='h1 mt-2'>Dashboard</div>
              <div className='h2 text-blue'>
                  Shipping never looked so good.
              </div>
              <div styleName='message'>
                  Shipping is complex, but great visualizations makes seeing
                  patterns simple. Predict trends, catch problems early, and
                  make your presentations look great. Now with filtering,
                  advanced search and unlimited custom graphics.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgIphoneDashboard, ImgIphoneDashboard2x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <DashboardDetailsGrid />
      <MobileGeographySection />
      <DashboardReportingAuditingSplash />
      <UptimeSplash />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/dashboard.js